import { useSyncExternalStore } from "react";

/**
 * Viewport-width "mobile" detekce na breakpointu `lg` (Tailwind: 1024px).
 * Sdílený module-scoped matchMedia + useSyncExternalStore → jeden listener pro celý strom
 * (LayoutNodeView se volá rekurzivně pro každý uzel, takže per-component effect by byl drahý).
 *
 * Reprodukuje `stackOnMobile` chování původních stránek (`grid grid-cols-1 lg:grid-cols-2`):
 * < lg = true (stackovat do sloupce), >= lg = false.
 */
const QUERY = "(max-width: 1023px)";

let mql: MediaQueryList | null = null;
const getMql = (): MediaQueryList | null => {
  if (typeof window === "undefined") return null;
  if (!mql) mql = window.matchMedia(QUERY);
  return mql;
};

const subscribe = (cb: () => void): (() => void) => {
  const m = getMql();
  if (!m) return () => {};
  m.addEventListener("change", cb);
  return () => m.removeEventListener("change", cb);
};

const getSnapshot = (): boolean => getMql()?.matches ?? false;
const getServerSnapshot = (): boolean => false;

export const useIsMobile = (): boolean => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
